import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";
import { Grid } from "@mui/material";
import {
    DeleteButton,
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    LabelPosition,
    ResetButton,
    RHookFormTextFieldWithLabel,
    SubmitButton,
} from "@websential/cosmic-v20";

export interface IWebROESubmissionToolbar {
    onResetClicked: () => void;
    onDeleteClicked: () => void;
    appliedShowEmployees: number;
    appliedShowArchive: boolean;
	onChangeFileAcceptedHandler: () => void,
    onChangeFileRejectedHandler: () => void,
    onChangeArchiveHandler: () => void,
    onChangeRemoveArchiveHandler: () => void,
    // isSubmitting: boolean;
    // editRecordId: any;
}

export const WebROESubmissionToolbar: FC<IWebROESubmissionToolbar> = ({
    onResetClicked,
    onDeleteClicked,
    appliedShowEmployees,
    appliedShowArchive,
    onChangeFileAcceptedHandler,
    onChangeFileRejectedHandler,
    onChangeArchiveHandler,
    onChangeRemoveArchiveHandler,
    // isSubmitting = false,
    // editRecordId,
}) => {
    const isROECreated = appliedShowEmployees === 300;
    const isFileGenerated = appliedShowEmployees === 100;
    const isFileProcessed = appliedShowEmployees === 200;

    return (
        <Toolbar>
            <>
            
                {isROECreated && (
                 <>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{ marginRight:"1rem", marginTop:"1rem"}}>

                <EnhancedDropDownRHFWithLabel
                label="Web Processing Method"
                selectName="webProcessingMethod"
                testId="web-processing-method"
                labelPosition={LabelPosition.Top}
                items={[
                    { label: "Store as Draft", value: 100 },
                    { label: "To be Submitted", value: 200 },
                 ]}/>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{ marginRight:"1rem", marginTop:"1rem"}}>

                        <RHookFormTextFieldWithLabel
                            label="File Name"
                            id="fileName"
                            testId="file-name"
                            labelPosition={LabelPosition.Top}
                        />
                   
                    </Grid>
                    </>
                )}


                {isROECreated && (
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{
                    marginRight:"1rem"
                }}>
                    <>
                    <EnhancedButtonPrimeReact
                         label="Create ROE Web"
                         type="submit"
                         raised
                         severity={EnhancedButtonPrimeReactSeverity.Success}/>
                    </>
                 </Grid>)}


                {isFileProcessed && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{marginRight:"1rem"}}>   
                <EnhancedButtonPrimeReact
                label="Delete"
                raised
                onClickHandler={onDeleteClicked}
                style={{ marginLeft: "1rem" }}
                severity={EnhancedButtonPrimeReactSeverity.Danger}
                /></Grid>)} 



        {(isROECreated || isFileProcessed || isFileGenerated) && (
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
           sx={{marginRight:"1rem" }}>

                <EnhancedButtonPrimeReact
                // label={isROECreated && appliedShowArchive ? "Remove Archive" : "Archive"}
                label={ appliedShowArchive ? "Remove Archive" : "Archive"}
                raised
                severity={EnhancedButtonPrimeReactSeverity.Secondary}
                onClickHandler={
        appliedShowArchive
            ? onChangeRemoveArchiveHandler
            : onChangeArchiveHandler
    }
                />
                </Grid>)}
                


                {isFileGenerated && (
                    <>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}  sx={{marginRight:"1rem"}}>
                        <EnhancedButtonPrimeReact
                            label="File Rejected"
                            raised
                            severity={EnhancedButtonPrimeReactSeverity.Secondary}
                            onClickHandler={onChangeFileRejectedHandler}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <EnhancedButtonPrimeReact
                            label="File Accepted"
                            raised
                            severity={EnhancedButtonPrimeReactSeverity.Secondary}
                            onClickHandler={onChangeFileAcceptedHandler}
                        />
                    </Grid>
                    </>
                )}
            </>
        </Toolbar>
    );
};

//  => {
//     return (
//         <Toolbar>
//             <>
//                 {/* <EnhancedDropDownRHFWithLabel
//                     label="Web Processing Method"
//                     selectName="webProcessingMethod"
//                     testId={`web-processing-method`}
//                     labelPosition={LabelPosition.Top}
//                     items={[
//                         {
//                             label: "Store as Draft",
//                             value: 100,
//                         },
//                         {
//                             label: "To be Submitted",
//                             value: 200,
//                         },
//                     ]}
//                 />

//                 <RHookFormTextFieldWithLabel
//                     label="File Name"
//                     id="fileName"
//                     testId={`file-name`}
//                     labelPosition={LabelPosition.Top}
//                 /> */}

//                 <EnhancedButtonPrimeReact
//                     label="Create ROE Web"
//                     type="submit"
//                     raised
//                     severity={EnhancedButtonPrimeReactSeverity.Success}
//                 />
//                 <EnhancedButtonPrimeReact
//                     label="Archive"
                   
//                     raised
//                     severity={EnhancedButtonPrimeReactSeverity.Secondary}
//                 />
//                 <EnhancedButtonPrimeReact
//                     label="File Rejected"
                   
//                     raised
//                     severity={EnhancedButtonPrimeReactSeverity.Secondary}
//                 />
//                 <EnhancedButtonPrimeReact
//                     label="File Accepted"
                
//                     raised
//                     severity={EnhancedButtonPrimeReactSeverity.Secondary}
//                 />
//                 <EnhancedButtonPrimeReact
//                     // icon="pi pi-trash"
//                     label="Delete"
//                     raised
//                     onClickHandler={onDeleteClicked}
//                     style={{ marginLeft: "1rem" }}
//                     severity={EnhancedButtonPrimeReactSeverity.Danger}
//                     // disabled={!editRecordId ? true : false}
//                 />
//             </>
//         </Toolbar>
//     );
// };
